var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgStripefees = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,0.8h16c1.8,0,3.2,1.4,3.2,3.2v16c0,1.8-1.4,3.2-3.2,3.2H4c-1.8,0-3.2-1.4-3.2-3.2V4C0.8,2.2,2.2,0.8,4,0.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M11,9.2c0-0.6,0.5-0.8,1.3-0.8c1.4,0,2.7,0.4,3.9,1V5.7C15,5.2,13.7,5,12.3,5C9.1,5,7,6.6,7,9.3 c0,4.3,6,3.6,6,5.4c0,0.7-0.6,0.9-1.5,0.9c-1.3,0-3-0.5-4.3-1.2v3.7C8.5,18.7,10,19,11.5,19c3.3,0,5.5-1.6,5.5-4.3 C17,10.1,11,10.9,11,9.2L11,9.2z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStripefees, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stripefees.16dc1955.svg";
export { ForwardRef as ReactComponent };